var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8f8f8;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9695",
    "data-name": "Group 9695",
    transform: "translate(-214 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9685",
    "data-name": "Group 9685",
    transform: "translate(214 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    className: "cls-2",
    d: "M310,96H246a32,32,0,1,1,0-64h4v4h-4a28,28,0,1,0,0,56h64a28,28,0,0,0,0-56h-4V32h4a32,32,0,0,1,0,64Z",
    transform: "translate(-214 -32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9686",
    "data-name": "Group 9686",
    transform: "translate(222 68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    className: "cls-2",
    d: "M306,84H242a24,24,0,1,1,0-48h4v4h-4a20,20,0,1,0,0,40h64a20,20,0,0,0,0-40h-4V36h4a24,24,0,0,1,0,48Z",
    transform: "translate(-218 -36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9687",
    "data-name": "Group 9687",
    transform: "translate(254 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    className: "cls-2",
    d: "M276,46H240a5.893,5.893,0,0,1-6-6V36a5.893,5.893,0,0,1,6-6h10v4H240a1.89,1.89,0,0,0-2,2v4a1.89,1.89,0,0,0,2,2h36a1.89,1.89,0,0,0,2-2V36a1.89,1.89,0,0,0-2-2H266V30h10a5.893,5.893,0,0,1,6,6v4A5.893,5.893,0,0,1,276,46Z",
    transform: "translate(-234 -30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9688",
    "data-name": "Group 9688",
    transform: "translate(274 52)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1749",
    "data-name": "Ellipse 1749",
    className: "cls-2",
    cx: 4,
    cy: 4,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9689",
    "data-name": "Group 9689",
    transform: "translate(269.6 44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    className: "cls-2",
    d: "M255.8,30.4a7.9,7.9,0,0,0-5.6-2.4,7.263,7.263,0,0,0-5.6,2.4l-2.8-2.8a11.976,11.976,0,0,1,8.4-3.6,11.2,11.2,0,0,1,8.4,3.6Z",
    transform: "translate(-241.8 -24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9690",
    "data-name": "Group 9690",
    transform: "translate(263.8 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    className: "cls-2",
    d: "M241.7,28.6l-2.8-2.8a20.283,20.283,0,0,1,28.4,0l-2.8,2.8A15.856,15.856,0,0,0,253.1,24,16.55,16.55,0,0,0,241.7,28.6Z",
    transform: "translate(-238.9 -20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9691",
    "data-name": "Group 9691",
    transform: "translate(258.2 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    className: "cls-2",
    d: "M272.9,27a24.143,24.143,0,0,0-34,0l-2.8-2.8a28,28,0,0,1,39.6,0Z",
    transform: "translate(-236.1 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9692",
    "data-name": "Group 9692",
    transform: "translate(276 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2749",
    "data-name": "Rectangle 2749",
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9693",
    "data-name": "Group 9693",
    transform: "translate(284 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9694",
    "data-name": "Group 9694",
    transform: "translate(268 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2751",
    "data-name": "Rectangle 2751",
    className: "cls-2",
    width: 4,
    height: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdWhite);
export default __webpack_public_path__ + "static/media/mdWhite.e20e2e7da19b6500af3485f9d00cff8c.svg";
export { ForwardRef as ReactComponent };